/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import { useAuthStore } from '../store';
import { hasPermission, type Action } from '../utils/rbac';
import type { Role } from '../types';

/**
 * Hook providing current user, auth state, and permission checking.
 */
export function useAuth() {
  const { user, token, isAuthenticated, isLoading, setAuth, clearAuth, setLoading } = useAuthStore();

  const can = (resource: string, action: Action): boolean => hasPermission(user?.role, resource, action);

  const hasRole = (role: Role): boolean => user?.role === role;

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    setAuth,
    clearAuth,
    setLoading,
    can,
    hasRole,
    role: user?.role,
  };
}
